import React from "react";
import { retrieveDelegateAccess } from "../api/DelegateAPI";
import { refreshAccessToken } from "../api/oauthAPI";

export default function FirmContactRow(props) {

  async function handleSubmit(fcEid) {

    props.setSpinnerActive(true)
    let token = props.user.access_token;
    if (props.user.expired) {
      token = await refreshAccessToken(props.user.refresh_token);
    }

    let resp = null;
    if(fcEid !== null && fcEid !== undefined && props.firmEid !== null && props.firmEid !== undefined) {
      const singleFirmEid = props.firmEid.substring(0,9)
      resp= await retrieveDelegateAccess(token, singleFirmEid, fcEid)
    }
      props.setFcDisplayResponse(resp)

      props.setSpinnerActive(false)

  }
    const buttonID = "select" + props.eid;

    return (
    <tr id={props.eid} >
    <td className="pds-dataTable-table-item pds-dataTable-sort-fname">{props.name.firstName}</td>
    <td className="pds-dataTable-table-item pds-dataTable-sort-lname">{props.name.lastName}</td>
    <td className="pds-dataTable-table-item pds-dataTable-sort-eid">{props.eid}</td>
    <td> <button
        className="pds-button pds-button-primary"
        data-gtm="modal-cta"
        id={buttonID}
        onClick={() => handleSubmit(props.eid)}
      >
        Select
      </button></td>
    </tr>
    )
}
